import React from "react";
import LegalPage from "./LegalPage";
import { SITE } from "@/lib/site";

export default function Privacy() {
  return (
    <LegalPage
      path="/privacy"
      heading="Privacy Policy"
      updated="September 2026"
      title="Privacy Policy | Registry Feed"
      description="Registry Feed's privacy policy — what information we collect from account holders, how we handle it and your rights over that data."
    >
      <p>Registry Feed ("we", "us", "our", the "brand") respects the privacy of everyone who visits or subscribes to our services. This policy explains what personal information we collect from you, why, and how we handle it.</p>
      <h2>Information we collect</h2>
      <ul>
        <li><strong>Account information</strong> — name, business email, phone number, company name — provided when you register.</li>
        <li><strong>Subscription details</strong> — the packages you buy, the filters you choose, your download history inside the dashboard.</li>
        <li><strong>Sample-request information</strong> — email address used to request a sample, plus the criteria you selected.</li>
        <li><strong>Technical information</strong> — IP address, browser type, and basic device information collected via server logs and cookies.</li>
      </ul>
      <h2>How we use this information</h2>
      <ul>
        <li>To create and operate your Registry Feed account.</li>
        <li>To deliver the data you subscribed to and to send transactional notifications about new files, renewals and account changes.</li>
        <li>To detect and prevent abuse of our services.</li>
        <li>To comply with applicable laws.</li>
      </ul>
      <h2>Data we sell to subscribers</h2>
      <p>The company records our subscribers download from our dashboard consist of information that is publicly filed by companies with the Registrar of Companies (ROC) and the Goods and Services Tax Network (GSTN). We do not sell your personal account information as part of our data products.</p>
      <h2>Sharing</h2>
      <p>We do not sell your personal account information. We share it only with service providers that help us run the platform (hosting, email delivery, analytics) and only to the extent necessary. We may disclose information if legally required.</p>
      <h2>Cookies</h2>
      <p>We use essential cookies (for authentication and session management) and lightweight analytics. See our <a href="/cookie-policy">Cookie Policy</a> for details.</p>
      <h2>Retention</h2>
      <p>We keep your account information for as long as you have an active account, and for a reasonable period thereafter to comply with legal, accounting and audit obligations. Sample-flow data is retained briefly and then deleted.</p>
      <h2>Your rights</h2>
      <p>You may request access, correction, or deletion of your account information by contacting <a href={`mailto:${SITE.salesEmail}`}>{SITE.salesEmail}</a>.</p>
      <h2>Contact</h2>
      <p>For questions about this policy, email <a href={`mailto:${SITE.salesEmail}`}>{SITE.salesEmail}</a>.</p>
    </LegalPage>
  );
}
